import axios from 'axios';
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import validate from 'validate.js';
import _ from 'lodash';

const {
  addRequestError,
  addErrorsSaga,
  addValidateError,
  cleanErrors,
  addAdminPartners,
  startRequest,
  endRequest,
  setTempPartner
} = actions;

const {
  UPDATE_PARTNER_SAGA,
  LOAD_ADMIN_PARTNERS_SAGA,
  ADMIN_DELETE_PARTNERS_SAGA,
  CREATE_PARTNER_SAGA,
  API_ADMIN_PARTNERS,
  LOAD_PARTNER_SAGA
} = constants;

const apiCreatePartner = (partner) => (
  axios.post(API_ADMIN_PARTNERS, partner)
);

const apiUpdatePartner = (id, partner) => (
  axios.put(`/api/v1/admin/partnerships/${id}`, partner)
);

const apiLoadAdminPartners = (page, query) => (
  axios.get(API_ADMIN_PARTNERS, {
    params: {
      page,
      per_page: 5,
      ...query
    }
  })
);

const apiLoadPartner = (id, params = {}) => (
  axios.get(`/api/v1/admin/partnerships/${id}`, {
    params: {
      ...params
    }
  })
);


const apiDeletePartners = (partner_ids) => {
  return axios.post('/api/v1/admin/partnerships/destroy', {
    partner_ids: partner_ids
  })
}

const formatRequestData = (partner) => {
  let data = new FormData();

  Object.keys(partner).forEach(field => {
    if (field === 'logo') return;
    data.append(`partnership[${field}]`, partner[field]);
  });

  if (partner.logo instanceof File) {
    data.append('partnership[logo]', partner.logo);
  }

  return data;
}


function* createPartnerSaga({ partner }) {
  try {
    if (yield select(store => store.requests.indexOf('partner_create') != -1))
      return;

    yield put(startRequest('partner_create'));

    const errors = validator.validate(partner, 'partner');
    if (errors) {
      yield put(addValidateError(CREATE_PARTNER_SAGA, errors));
      yield put(endRequest('partner_create'));
      return;
    } else {
      yield put(cleanErrors(CREATE_PARTNER_SAGA))
    }
    const partnerRequestData = yield call(formatRequestData, partner);
    const response = yield call(apiCreatePartner, partnerRequestData);
    const createdPartner = response.data.partnerships;
    toast.success('Partner successfully created!');
    yield put(push('/partnership/'));
    yield put(endRequest('partner_create'));
  } catch (e) {
    yield put(endRequest('partner_create'));
    yield put(addErrorsSaga(CREATE_PARTNER_SAGA, e.response))
  }
}

function* updatePartnerSaga({ partner }) {
  try {
    const errors = validator.validate(partner, 'partner');
    if (errors) {
      yield put(addValidateError(UPDATE_PARTNER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(UPDATE_PARTNER_SAGA))
    }

    const partnerRequestData = yield call(formatRequestData, partner);
    const response = yield call(apiUpdatePartner, partner.id, partnerRequestData);
    toast.success('Partner successfully updated!')
    yield put(push('/partnership/'))
  } catch (e) {
    yield put(addErrorsSaga(UPDATE_PARTNER_SAGA, e.response))
  }
}

function* deletePartners({ partner_ids }) {
  if (!partner_ids.length)
    return;
  const partnerIds = partner_ids;
  try {
    yield call(apiDeletePartners, partnerIds);
    toast.success('Partners successfully deleted!');
    const query = yield select(state => state.partners.admin.list.query) || {};
    const page = yield select(state => state.partners.admin.list.page) || 1;
    yield call(loadAdminPartners, { page, query });
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_DELETE_PARTNERS_SAGA, e.response))
  }
}

function* loadAdminPartners({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminPartners, page, query);
    const partners = response.data.partnerships;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminPartners(partners, count, page, totalPages, query));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* loadPartnerSaga({ id }) {
  try {
    const response = yield call(apiLoadPartner, id);
    const partner = response.data.partnership;
    yield put(setTempPartner(partner))

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* __createPartnerSaga() {
  yield takeEvery(CREATE_PARTNER_SAGA, createPartnerSaga);
}

function* __updatePartnerSaga() {
  yield takeEvery(UPDATE_PARTNER_SAGA, updatePartnerSaga);
}

function* __deletePartnerSaga() {
  yield takeEvery(ADMIN_DELETE_PARTNERS_SAGA, deletePartners);
}

function* __loadAdminPartners() {
  yield takeEvery(LOAD_ADMIN_PARTNERS_SAGA, loadAdminPartners)
}

function* __loadDashboardAdminPartners() {
  yield takeEvery(LOAD_ADMIN_PARTNERS_SAGA, loadAdminPartners)
}

function* __loadPartnerSaga() {
  yield takeEvery(LOAD_PARTNER_SAGA, loadPartnerSaga);
}

export {
  __createPartnerSaga,
  __updatePartnerSaga,
  __deletePartnerSaga,
  __loadAdminPartners,
  __loadPartnerSaga
};



// WEBPACK FOOTER //
// ./src/sagas/admin/partners.js